import request from '@/utils/request.js'

export function login(data){
    return request({
        url: 'sysUser/login',
        method: 'post',
        data
    })
}

export function getUserInfo(data){
    return request({
        url: 'sysUser/loginInfo',
        method: 'post',
        data
    })
}

export function modifyPwd(data){
    return request({
        url: 'sysUser/updatePwd',
        method: 'post',
        data
    })
}

export function addUser(data){
    return request({
        url: 'sysUser/add',
        method: 'post',
        data
    })
}

export function getUserList(data){
    return request({
        url: 'sysUser/listPage',
        method: 'post',
        data
    })
}

export function getOneUserInfo(data){
    return request({
        url: 'sysUser/detail',
        method: 'post',
        data
    })
}

//获取人员状态操作日志列表
export function getUserStateChangeRecord(data){
    return request({
        url: 'lunxun/select/info/sim',
        method: 'post',
        data
    })
}

export function editUserInfo(data){
    return request({
        url: 'sysUser/update',
        method: 'post',
        data
    })
}

export function resetUserPwd(data){
    return request({
        url: 'sysUser/resetPwd',
        method: 'post',
        data
    })
}

export function changeState(data){
    return request({
        url: 'sysUser/state',
        method: 'post',
        data
    })
}

export function addRole(data){
    return request({
        url: 'sysRole/add',
        method: 'post',
        data
    })
}

export function getMenuList(){
    return request({
        url: 'sysMenu/list',
        method: 'post',
        data: {}
    })
}

export function getRoleList(){
    return request({
        url: 'sysRole/list',
        method: 'post',
        data: {}
    })
}

export function getRoleListPage(data){
    return request({
        url: 'sysRole/listPage',
        method: 'post',
        data: data
    })
}

export function getOneRoleInfo(data){
    return request({
        url: 'sysRole/detail',
        method: 'post',
        data
    })
}

export function editRoleInfo(data){
    return request({
        url: 'sysRole/update',
        method: 'post',
        data
    })
}
export function changeRoleState(data){
    return request({
        url: 'sysRole/state',
        method: 'post',
        data
    })
}